import { useState, useEffect } from "react";

import SlotEventCardSimple from "./SlotEventCardSimple";

import { monthNumberToName } from "../utils/utils";

import moment from "moment";

export default ({
  day,
  selectedDate,
  events,
  onClickEvent,
  onClickSlot,
  onClickMore,
  onClickTitle,
}) => {
  const [dayEvents, setDayEvents] = useState([]);
  // Los eventos de calendarios de festivo no cuentan en el contador del día.
  const numCountedEvents = dayEvents.filter((event) => !event.festivo).length;
  const visibleDayEvents =
    dayEvents.length > 5 ? dayEvents.slice(0, 4) : dayEvents;

  const buildDayEvents = () => {
    const dayEvs = events.filter((event) => {
      return (
        event.visible &&
        moment(event.date, "YYYY-MM-DD").format("YYYY-MM-DD") ===
          day.format("YYYY-MM-DD")
      );
    });
    setDayEvents(dayEvs);
  };

  useEffect(() => {
    if (day) {
      buildDayEvents();
    }
  }, [events]);

  return (
    <div
      id={
        day && moment().format("YYYY-MM-DD") === day.format("YYYY-MM-DD")
          ? "calendar-month-day-today"
          : undefined
      }
      className="calendar-calendar-mes-semana-dia clickable-slot"
      style={{
        backgroundColor:
          day && (day.format("d") === "0" || day.format("d") === "6")
            ? "#e2f5ff"
            : selectedDate &&
                day &&
                selectedDate.format("MM") !== day.format("MM")
              ? "#f5f5f5"
              : "white",
      }}
      onClick={() => {
        onClickSlot(day.format("YYYY-MM-DD"), null);
      }}
    >
      {day && (
        <div
          className="calendar-calendar-date"
          style={{
            backgroundColor:
              day && moment().format("YYYY-MM-DD") === day.format("YYYY-MM-DD")
                ? "#4abeff"
                : "transparent",
            color:
              day && moment().format("YYYY-MM-DD") === day.format("YYYY-MM-DD")
                ? "white"
                : "#4a4a4a",
          }}
          onClick={(e) => {
            e.stopPropagation();
            onClickTitle(day);
          }}
        >
          {day.format("DD")}{" "}
          {monthNumberToName(day.format("MM"), true).slice(0, 3)}
          {numCountedEvents > 0 && (
            <div className="eventCounter">
              <div>
                <span>{numCountedEvents}</span>
              </div>
            </div>
          )}
        </div>
      )}
      <div className="calendar-calendar-mes-semana-dia-contenido">
        {visibleDayEvents.map((event, index) => {
          return (
            <SlotEventCardSimple
              key={index}
              event={event}
              numEvents={1}
              numEvent={0}
              onClickEvent={onClickEvent}
              forceSmall={true}
            />
          );
        })}
        {dayEvents.length > 5 && (
          <div
            className="slot-event-more"
            onClick={(e) => {
              e.stopPropagation();
              onClickMore(day);
            }}
          >
            {dayEvents.length - 4} más
          </div>
        )}
      </div>
    </div>
  );
};
